// @ts-check
import React from 'react';
import styles from './ExplainerModal.module.scss';
import { hideModal } from 'shared/actions/ModalActions';
import outboundSrc from '../InboundOrOutboundToggle/images/outbound_icon-focused.svg';
import inboundSrc from '../InboundOrOutboundToggle/images/inbound_icon-focused.svg';

const ExplainerModal = () => (
  <div className={styles.ExplainerModal_container}>
    <div className={styles.modal_header}>
      <h4>Outbound vs. Inbound Referrals</h4>
      <h5>Select based on the following:</h5>
    </div>
    <div className={styles.modal_body}>
      <div className={styles.column}>
        <div className={styles.icon_container}>
          <img className={styles.icon} src={outboundSrc} alt="outbound" />
        </div>
        <h4>Outbound</h4>
        <p>
          Choose outbound if you are referring a patient to another provider.
        </p>
      </div>
      <div className={styles.column}>
        <div className={styles.icon_container}>
          <img className={styles.icon} src={inboundSrc} alt="inbound" />
        </div>
        <h4>Inbound</h4>
        <p>
          Choose inbound if you are entering a referral you received outside of
          AristaMD from another provider.
        </p>
      </div>
    </div>
    <div className={styles.modal_footer}>
      <button className="btn btn-large" onClick={() => hideModal()}>
        Dismiss
      </button>
    </div>
  </div>
);

export default ExplainerModal;
